module.exports = __webpack_public_path__ + "media/alert-info-1.d3b3ccc5.mp3";